import { createContext } from 'react';
import type { User, MfaPendingState, MfaSetupResponse } from './auth-provider';

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  mfaPending: MfaPendingState | null;
  login: (email: string, password: string, rememberMe?: boolean) => Promise<{ requiresMfa: boolean }>;
  verifyMfa: (method: 'totp' | 'email', code: string) => Promise<void>;
  resendMfaEmail: () => Promise<void>;
  loadMfaSetup: () => Promise<MfaSetupResponse>;
  enableMfa: (totpCode: string) => Promise<void>;
  disableMfa: (totpCode: string) => Promise<void>;
  /** Erzwungene Einrichtung beim Login (Einrichtungs-Token statt Sitzung). */
  loadMfaEnrollment: () => Promise<MfaSetupResponse>;
  completeMfaEnrollment: (totpCode: string) => Promise<void>;
  register: (email: string, password: string, name: string) => Promise<void>;
  logout: () => Promise<void>;
  refreshUser: () => Promise<void>;

}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
